import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'

export default function ModalPodcast({isModalOpen, podcast, setIsModalOpen}) {
  return (
    <AnimatePresence>
        {isModalOpen && (
            <motion.div
            key="modal-background"
          onClick={() => setIsModalOpen(false)}
          className="fixed inset-0 bg-black/30 flex items-center justify-center z-20 p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
            >
                <motion.div
            key="modal-content"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-background rounded-lg shadow-xl p-6 font-sans w-full max-w-lg mx-4 border border-gray-200 flex flex-col max-h-[90vh] overflow-y-auto"
          >
            <h1 className='text-2xl text-text font-semibold ' > {podcast.nombre} </h1>
            
          </motion.div>

            </motion.div>
        )}

    </AnimatePresence>
  )
}
